import Styles from "./about.module.css";
import { Headline, Button, SubHeader } from "../../subcomponents/subcomponents";
export const About     = ( props ) =>{
    const { data: { logo, images, headlines, sections, team } = {} } = props;
    const { About } = Styles;
    return (
        <div className={ About }>
            {/*============header============*/}
            <header>
                <div><img src={ logo }/></div>
                <span></span>
                <h1>About Us</h1>
            </header>
            {/*============content===========*/}
            <main>
                <div>
                    <AboutImage       images    = { images    }/>
                    <HeadlinesSection headlines = { headlines }/>
                </div>
                <Sections    sections  = { sections  }/>
                {/*============footer============*/}
                <TeamSection team      = { team      }/>
                <Footer />
            </main>
        </div>
    );
};
const AboutImage       = ( props ) => {
    const { images = [] } = props;
    const { AboutImage  } = Styles;
    return (
        <div className={ AboutImage }>
            <img src={ images[Math.floor(Math.random() * images.length)] }/>
        </div>
    );
};
const HeadlinesSection = ( props ) => {
    const { headlines = []   } = props;
    const { HeadlinesSection } = Styles;
    return (
        <div className={ HeadlinesSection }>
            { 
                headlines.map(( value, key ) => {
                    const { icon, theme, text } = value;
                    return (
                        <Headline 
                            icon  = { icon  }
                            theme = { theme }
                            text  = { text  }
                            width = { 300   }
                            key   = { key   }
                        />
                    );
                })
            }
        </div>
    );
};
const Sections         = ( props ) => {
    const { sections = [] } = props;
    const { Sections      } = Styles;
    return (
        <div className={ Sections }>
            {
                sections.map(( value, key ) => {
                    const { title, text } = value;
                    return (
                        <Section 
                            title = { title }
                            text  = { text  }
                            key   = { key   }
                        />
                    );
                })
            }
        </div>
    );
};
const Section          = ( props ) => {
    const { title, text, width } = props;
    const { Section            } = Styles;
    return (
        <div className={ Section } style={{ maxWidth: width ? `${ width }px` : "100%" }}>
            <h1><bdi>{ title }</bdi></h1>
            <p ><bdi>{ text  }</bdi></p >
        </div>
    );
};
const TeamSection      = ( props ) => {
    const { team = []   } = props;
    const { TeamSection } = Styles;
    return (
        <div className={ TeamSection }>
            {/*===============header=============*/}
            <SubHeader
                icon = { <i className="bi bi-people-fill"></i> }
                text = { "Our Current team"                    }
            />
            {/*===============team===============*/}
            {
                team.map(( value, key ) => {
                    const { icon, text, theme, link } = value;
                    return (
                        <Headline 
                            icon  = { icon  }
                            text  = { text  }
                            theme = { theme }
                            width = { 300   }
                            link  = { link  }
                            key   = { key   }
                        />
                    );
                })
            }
            {/*===============footer=============*/}
            <span>are you curious? come join us</span>
            <Button
                icon  = { <i className="bi bi-envelope-at"></i> } 
                text  = { "Contact us"                          } 
                width = { 150                                   } 
                theme = { "#999"                                } 
                link  = { "/contact_us"                         }
            />
        </div>
    );
};
const Footer           = ( props ) => {
    const { } = props;
    const { Footer } = Styles;
    return (
        <footer className={ Footer }>
            <i className="bi bi-c-circle"></i>
            <span></span>
            <h1>Paradox</h1>
        </footer>
    );
};